/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


define(function() {
	const booleanProperties = ['weight', 'style'];

	const suffixToPart = {
		'size': 'fontSize',
		'family': 'font',
		'weight':'bold',
		'style': 'italic'
	};

	class  PropertiesHelper {

		static buildVidaFontPropertiesFromParts(VIPRUtils, fontChanges, currentFontProperty){
			const vidaFont = {
				'family': [],
				'size': null,
				'style': null,
				'weight': null
			};

			let parsedCurrentVidaFontProperty = currentFontProperty;
			if (typeof currentFontProperty === 'string') {
				parsedCurrentVidaFontProperty = VIPRUtils.parseVidaFontProperty(currentFontProperty);
			}
			parsedCurrentVidaFontProperty = parsedCurrentVidaFontProperty ? parsedCurrentVidaFontProperty : vidaFont;

			for (const fontPart in parsedCurrentVidaFontProperty){
				if(parsedCurrentVidaFontProperty.hasOwnProperty(fontPart) ){

					const part = suffixToPart[fontPart];

					//the steps to apply the value: 1) If changed states is valid, apply it;2)Then override the missing values from old property value;3) If changed states is null, apply null
					if (booleanProperties.indexOf(fontPart) !== -1){
						if(fontChanges[part]){
							vidaFont[fontPart] = part;
						}else if(typeof fontChanges[part] === 'undefined' && parsedCurrentVidaFontProperty[fontPart]){
							vidaFont[fontPart] = parsedCurrentVidaFontProperty[fontPart].toString();
						}
					}else  if (Array.isArray(vidaFont[fontPart])){
						//in text toolbar, we only supports one family option at one time, so the array length is no more than 1
						vidaFont[fontPart].length = 0;
						if(fontChanges[part]){
							vidaFont[fontPart].push(fontChanges[part]);
						}else if(typeof fontChanges[part] === 'undefined' && parsedCurrentVidaFontProperty[fontPart].length){
							vidaFont[fontPart].push( parsedCurrentVidaFontProperty[fontPart][0].toString());
						}
					}else{
						if(fontChanges[part]){
							vidaFont[fontPart] =  fontChanges[part];
						}else if(typeof fontChanges[part] === 'undefined' && parsedCurrentVidaFontProperty[fontPart]){
							vidaFont[fontPart] = parsedCurrentVidaFontProperty[fontPart].toString();
						}
					}
				}
			}

			const vidaFontValues = Object.keys(vidaFont).map(fontPart => vidaFont[fontPart]);
			const vidaFontProperty = VIPRUtils.createVidaFontProperty(vidaFontValues);
			//vida does not accept empty string, need to convert the empty string to null value
			const vidaFontString = vidaFontProperty && vidaFontProperty.toString ? vidaFontProperty.toString() : null;
			const propertyValueToApply = vidaFontString === '' ? null : vidaFontString;

			return propertyValueToApply;
		}

		static getVidaFontPropertiesPart(VIPRUtils, part, fontPropertyValue){
			let vidaFontValue = fontPropertyValue;
			if (typeof fontPropertyValue === 'string') {
				vidaFontValue = VIPRUtils.parseVidaFontProperty(fontPropertyValue);
			}
			var fontPropValue = vidaFontValue && vidaFontValue[part] ? vidaFontValue[part] : null;
			var isBooleanProperty = booleanProperties.indexOf(part) !== -1;
			if (fontPropValue) {
				if (isBooleanProperty) {
					return true;
				} else if (part === 'size' && typeof fontPropValue === 'object')  {
					let fontvalue = fontPropValue['value'].toString() + fontPropValue['unit'].toString();
					return fontvalue;
				} else {
					return fontPropValue.toString();
				}
			} else {
				return isBooleanProperty ? false : null;
			}
		}

		static splitEscapedString(input, delimiter, outputs) {
			const index = input.indexOf(delimiter);
			if(index !== -1 && index !== input.length && input[index-1] !== '\\') {
				const result = input.slice(0, index);
				input = input.slice(index+1, input.length);
				outputs.push(result);
				PropertiesHelper.splitEscapedString(input, delimiter, outputs);
			} else {
				outputs.push(input);
			}
		}

	}
	return PropertiesHelper;
});
